import type { ReduxRootState } from 'types';

interface Params {
  isJoinPage?: boolean;
  isStrategyLocal: boolean;
  language: ReduxRootState['language'];
  serverConfig: Pick<
    ReduxRootState['serverConfig'],
    | 'authStrategies'
    | 'joinPageLoginCustomContent'
    | 'joinPageLoginCustomContentBeside'
    | 'joinPageLoginCustomContentLocales'
    | 'localLoginCustomContent'
    | 'localLoginCustomContentBeside'
    | 'localLoginCustomContentLocales'
    | 'loginCustomContent'
    | 'loginCustomContentBeside'
    | 'loginCustomContentLocales'
  >;
}

const getCustomContentBasedOnLoginStrategy = ({
  isJoinPage = false,
  isStrategyLocal,
  language,
  serverConfig
}: Params) => {
  //we are checking for additional strategies, because if there is one, we use the default login customizations
  //as default instead of the local ones, so that we can display them before selecting a local login strategy
  const hasAdditionalStrategies = serverConfig.authStrategies.some(
    (strategy) => !strategy.hideFromLogin
  );

  let customContent: string | null;
  let customContentBeside: boolean;
  if (!hasAdditionalStrategies || isStrategyLocal) {
    // we know we are in the local login screen
    customContent =
      (isJoinPage
        ? serverConfig.joinPageLoginCustomContentLocales?.[language] ||
          serverConfig.joinPageLoginCustomContent
        : null) ||
      serverConfig.localLoginCustomContentLocales?.[language] ||
      serverConfig.localLoginCustomContent ||
      serverConfig.loginCustomContentLocales?.[language] ||
      serverConfig.loginCustomContent;

    customContentBeside =
      (isJoinPage ? serverConfig.joinPageLoginCustomContentBeside : null) ||
      serverConfig.localLoginCustomContentBeside ||
      serverConfig.loginCustomContentBeside;
  } else {
    customContent =
      serverConfig.loginCustomContentLocales?.[language] ||
      serverConfig.loginCustomContent;
    customContentBeside = serverConfig.loginCustomContentBeside;
  }

  return { customContent, customContentBeside };
};

export default getCustomContentBasedOnLoginStrategy;
